export const primaryColor = '#0094a0';
